// @ts-nocheck
import React from 'react';
import Statistics from 'components/access/Statistics';

const PenlyAccessStatistics = () => (
    <Statistics />
);

export default PenlyAccessStatistics;
